<template>
    <div>
        <flash-error ref="flashError"></flash-error>
        <progress-bar percentages="50"></progress-bar>
        <section id="service-section" class="py-2 mobile-container">
            <div class="d-flex align-items-center justify-content-between text-light">
                <div>Leveringsoplysninger</div>
                <div>
                    <div class="info-box d-flex align-items-center justify-content-center cursor-pointer"
                         @click="openModalIframe"
                    >
                        <span class="material-symbols-outlined" style="font-size: 20px;">info_i</span>
                    </div>
                </div>
            </div>
        </section>
        <section id="contact-section" class="mobile-container bg-light">
            <div class="py-2 font-larger">
                <div class="row">
                    <div class="col-10">
                        <div class="mb-2">{{ booking.dropoff_address.name }}</div>
                        <div class="mb-2">
                            {{ booking.dropoff_address.street }},
                            {{ booking.dropoff_address.zip }}
                            {{ booking.dropoff_address.city }},
                            <span v-if="booking.dropoff_address.country">{{ booking.dropoff_address.country.name }}</span>
                        </div>
                        <div class="mb-2">{{ booking.dropoff_address.phone }}</div>
                        <div>
                            <button class="btn btn-success" @click="goNext">Næste STEP</button>
                        </div>
                    </div>
                    <div class="col-2">
                        <span class="material-icons-outlined cursor-pointer text-primary"
                              title="Edit info"
                              @click="toggleModal('infoModal')"
                        >edit</span>
                    </div>

                </div>

            </div>
        </section>
        <back-section :url="prevUrl" type="1"></back-section>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ændring af adresse</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal('modal')"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <div v-if="configurations['change_address']['value'] > 0">
                                 En adresse ændring koster et gebyr på {{ calculatePriceWithVatAndRoundToNearestTens(configurations['change_address']['value']) }} DKK.
                            </div>
                            <div v-if="configurations['days_autopush']['value'] > 0">
                                Vi skal gøre opmærksom på at din levering vil blive skubbet minimum
                                {{ configurations['days_autopush']['value'] }} dag(e) såfremt
                                du ændrer postnummeret nedenfor.
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label for="name" class="mb-0 font-weight-bold">Name</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newDropoffAddress.name == '' && isSubmit? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none"
                                           placeholder="Name"
                                           id="name"
                                           v-model="newDropoffAddress.name"
                                           @change="validate(false)"
                                    >
                                </div>
                                <div class="text-danger" v-if="errors.name">{{ errors.name }}</div>
                            </div>
                            <div class="form-group">
                                <label for="street" class="mb-0 font-weight-bold">Street</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newDropoffAddress.street == '' && isSubmit? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none"
                                           placeholder="Street"
                                           id="street"
                                           v-model="newDropoffAddress.street"
                                           @change="validate"
                                    >
                                </div>
                                <div class="text-danger" v-if="errors.street">{{ errors.street }}</div>
                            </div>
                            <div class="form-group">
                                <label for="zip" class="mb-0 font-weight-bold">Zip</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newDropoffAddress.zip == '' && isSubmit? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none"
                                           placeholder="Zip"
                                           id="zip"
                                           v-model="newDropoffAddress.zip"
                                           @change="validate"
                                    >
                                </div>
                                <div class="text-danger" v-if="errors.zip">{{ errors.zip }}</div>
                            </div>
                            <div class="form-group">
                                <label for="city" class="mb-0 font-weight-bold">City</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newDropoffAddress.city == '' && isSubmit? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none"
                                           placeholder="City"
                                           id="city"
                                           v-model="newDropoffAddress.city"
                                           @change="validate"
                                    >
                                </div>
                                <div class="text-danger" v-if="errors.city">{{ errors.city }}</div>
                            </div>
                            <div class="form-group">
                                <label for="phone" class="mb-0 font-weight-bold">Phone</label>
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newDropoffAddress.phone == '' && isSubmit? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none"
                                           placeholder="Phone"
                                           id="phone"
                                           v-model="newDropoffAddress.phone"
                                           @change="validate(false)"
                                    >
                                </div>
                                <div class="text-danger" v-if="errors.phone">{{ errors.phone }}</div>
                            </div>

                            <button class="btn btn-primary mb-1"
                                    :disabled="Object.keys(this.errors).length > 0"
                                    @click="saveChanges">
                                Save
                            </button>
                            <div class="text-danger" v-if="errors.general">{{ errors.general }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            ref="infoModal"
            class="modal fade"
            :class="{show, 'd-block': activeInfoModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Bemærkning</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal('infoModal')"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
<!--                            <span>Bemærk at du er ved at foretage ændringer i dine leveringsoplysninger.</span>-->
                            <div v-if="configurations['change_address']['value'] > 0">
                                Det koster et gebyr på {{ calculatePriceWithVatAndRoundToNearestTens(configurations['change_address']['value']) }} DKK.
                            </div>
                            <div v-if="configurations['days_autopush']['value'] > 0">
                                Vi skal gøre opmærksom på at din levering vil blive skubbet minimum
                                {{ configurations['days_autopush']['value'] }} dag(e) såfremt du ændrer postnummeret nedenfor.
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between">
                            <button class="btn btn-primary mb-1" @click="toggleModal('infoModal')">Afbryd</button>
                            <button class="btn btn-success mb-1"
                                    @click="toggleModal('infoModal'); toggleModal('modal');"
                            >Ok</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal-iframe ref="modal-iframe"
                      @toggleActiveIframeModalInterval="toggleActiveIframeModalInterval"
        ></modal-iframe>
        <div v-if="activeModalInterval || activeIframeModalInterval || activeInfoModalInterval"
             class="modal-backdrop fade show"
        ></div>

    </div>

</template>

<script>
import ProgressBar from "./reusable/ProgressBar.vue";
import BackSection from "./reusable/BackSection.vue";
import ModalIframe from "./reusable/ModalIframe.vue";

import FlashError from "./reusable/FlashError.vue";
import priceMixin from "../../mixins/priceMixin";
import dateTimeMixin from "../../mixins/dateTimeMixin";
export default {
    name: "CmfStep3",
    components: {FlashError, ModalIframe, ProgressBar, BackSection},
    mixins: [priceMixin, dateTimeMixin],
    props: {
        booking: {type: Object, required: true},
        configurations: {type: Object, required: true},
        nextUrl: {type: String, required: true},
        prevUrl: {type: String, required: true},
        applyChangesUrl: {type: String, required: true},
        changeDeliveryInfoUrl: {type: String, required: true},
        changeAddressKey: {type: String, required: true},
        additionalServicesProp: {type: Object|Array, required: true},
    },
    data() {
        return {
            activeModalInterval: false,
            activeIframeModalInterval: false,
            activeInfoModalInterval: false,
            additionalServices: {},
            errors: {},

            newDropoffAddress: this.booking.dropoff_address ?
                JSON.parse(JSON.stringify(this.booking.dropoff_address)) :
                {},
            show: false,
            isSubmit: false,
        }
    },
    created() {
        if (this.additionalServicesProp[this.changeAddressKey]) {
            this.setAddressFromSession('newDropoffAddress');
            this.setAddressFromSession();
        }
    },
    methods: {
        goNext() {
            window.location.href = this.nextUrl;
        },
        openModalIframe() {
            this.$refs["modal-iframe"].toggleModal();
        },
        toggleActiveIframeModalInterval() {
            this.activeIframeModalInterval = !this.activeIframeModalInterval;
        },
        setAddressFromSession(type = '') {
            if (type === 'newDropoffAddress') {
                this.$set(this.newDropoffAddress, 'name', this.additionalServicesProp[this.changeAddressKey]['value'].name);
                this.$set(this.newDropoffAddress, 'street', this.additionalServicesProp[this.changeAddressKey]['value'].street);
                this.$set(this.newDropoffAddress, 'city', this.additionalServicesProp[this.changeAddressKey]['value'].city);
                this.$set(this.newDropoffAddress, 'zip', this.additionalServicesProp[this.changeAddressKey]['value'].zip);
                this.$set(this.newDropoffAddress, 'phone', this.additionalServicesProp[this.changeAddressKey]['value'].phone);
            } else {
                this.$set(this.booking.dropoff_address, 'name', this.additionalServicesProp[this.changeAddressKey]['value'].name);
                this.$set(this.booking.dropoff_address, 'street', this.additionalServicesProp[this.changeAddressKey]['value'].street);
                this.$set(this.booking.dropoff_address, 'city', this.additionalServicesProp[this.changeAddressKey]['value'].city);
                this.$set(this.booking.dropoff_address, 'zip', this.additionalServicesProp[this.changeAddressKey]['value'].zip);
                this.$set(this.booking.dropoff_address, 'phone', this.additionalServicesProp[this.changeAddressKey]['value'].phone);
            }
        },
        toggleModal(ref = 'modal') {
            const body = document.querySelector("body");
            if (ref === 'modal') {
                this.activeModalInterval = !this.activeModalInterval;
            } else {
                this.activeInfoModalInterval = !this.activeInfoModalInterval;
            }
            this.activeModalInterval || this.activeInfoModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);

            if (ref === 'modal' && !this.activeModalInterval) { // We close the modal without saving
                this.errors = {};
                if (this.additionalServicesProp[this.changeAddressKey]) {
                    this.setAddressFromSession('newDropoffAddress');
                } else {
                    this.newDropoffAddress = JSON.parse(JSON.stringify(this.booking.dropoff_address));
                }
            }
        },
        async saveChanges() {
            const validationResult = await this.validate();
            if (!validationResult) {
                return;
            }

            this.isSubmit = true;

            axios.patch( this.changeDeliveryInfoUrl, this.newDropoffAddress)
                .then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Success',
                        time: 3000,
                        blockClass: 'flash-message'
                    });
                    this.$set(this.booking, 'dropoff_address', JSON.parse(JSON.stringify(this.newDropoffAddress)));
                    setTimeout(() => {
                        this.toggleModal();
                    }, 1000);
                }).catch(error => {
                this.$refs.flashError.flashError(error);
                if (error.response.data && error.response.data.errors) {
                    for(let key in error.response.data.errors) {
                        this.$set(this.errors, key, error.response.data.errors[key][0])
                    }
                }
            }).finally(() => {
                this.isSubmit = false;
            });

        },
        validate(validateWithGoogleMaps = true) {
            return new Promise((resolve) => {
                this.errors = {};
                // Validation step 1
                let isValid = true;
                if (!this.newDropoffAddress.zip) {
                    isValid = false;
                    this.$set(this.errors, 'zip', 'Zip is required');
                } else if (this.newDropoffAddress.zip.length < 4) {
                    isValid = false;
                    this.$set(this.errors, 'zip', 'Invalid Zip ');
                }
                if (!this.newDropoffAddress.street) {
                    isValid = false;
                    this.$set(this.errors, 'street', 'Address is required');
                } else if (this.newDropoffAddress.street.length < 4) {
                    isValid = false;
                    this.$set(this.errors, 'street', 'Invalid Street ');
                }
                if (!this.newDropoffAddress.city) {
                    isValid = false;
                    this.$set(this.errors, 'city', 'City is required');
                } else if (this.newDropoffAddress.city.length < 2) {
                    isValid = false;
                    this.$set(this.errors, 'city', 'Invalid City ');
                }
                if (!this.newDropoffAddress.name) {
                    isValid = false;
                    this.$set(this.errors, 'name', 'Name is required');
                }
                if (!this.newDropoffAddress.phone) {
                    isValid = false;
                    this.$set(this.errors, 'phone', 'Phone is required');
                } else if (this.newDropoffAddress.phone.length < 6) {
                    isValid = false;
                    this.$set(this.errors, 'phone', 'Invalid phone ');
                }

                if (!this.errors['zip'] &&
                    (this.booking.dropoff_address.zip < 5000 && this.newDropoffAddress.zip > 5000) ||
                    (this.booking.dropoff_address.zip > 5000 && this.newDropoffAddress.zip < 5000)) {
                    isValid = false;
                    this.errors['zip'] = 'Det er ikke muligt at skifte til et postnummer på den anden side af Storebæltsbroen.';
                }

                if (!isValid) {
                    resolve(false);
                    return;
                } else if(!validateWithGoogleMaps) {
                    resolve(true);
                    return;
                }

                // Validation step 2
                const regionCode = this.booking.dropoff_address.country.code ? this.booking.dropoff_address.country.code : 'DK';
                let address = {};
                if (this.booking.dropoff_address.country && this.booking.dropoff_address.country.code) {
                    address.regionCode = this.booking.dropoff_address.country.code;
                }

                axios.post(`https://addressvalidation.googleapis.com/v1:validateAddress?key=AIzaSyDSSw89RnoedD7ChwJE6p2ACQ3GfMDqS1A`, {
                        "address": {
                            "regionCode": regionCode,
                            "postalCode": this.newDropoffAddress.zip,
                            "addressLines": [`${this.newDropoffAddress.street}, ${this.newDropoffAddress.city}`]
                        },
                    }
                ).then((response) => {
                    console.log(response.data.result);
                    if (['ROUTE', 'OTHER'].includes(response.data.result.verdict.validationGranularity) ||
                        !response.data.result.verdict.addressComplete
                    ) {
                        this.$set(this.errors, 'general', "There isn't enough information for the delivery. Or some information isn't valid" );
                        resolve(false);
                    } else {
                        let postalAddress = response.data.result.address.postalAddress;
                        console.log(postalAddress);
                        if (!postalAddress.postalCode || postalAddress.postalCode != this.newDropoffAddress.zip) {
                            console.log('Invalid zip');
                            if (postalAddress.postalCode) {
                                this.$set(this.errors, 'zip', `Did you mean this one: ${postalAddress.postalCode}?`);
                            }
                            isValid = false;
                        } else if(!postalAddress.locality || postalAddress.locality !== this.newDropoffAddress.city) {
                            console.log('Invalid city');
                            if (postalAddress.locality) {
                                this.$set(this.errors, 'city', `Did you mean this one: ${postalAddress.locality}?`);
                            }
                            isValid = false;
                        } else if(!postalAddress.addressLines || !postalAddress.addressLines[0] || postalAddress.addressLines[0] !== this.newDropoffAddress.street) {
                            console.log('Invalid street');
                            let message = '';
                            if (postalAddress.addressLines || postalAddress.addressLines[0]) {
                                message = `Did you mean this one: ${postalAddress.addressLines[0]}?`
                            }
                            this.$set(this.errors, 'street', `Invalid Street. ${message}`);
                            isValid = false;
                        } else if(!postalAddress.regionCode || postalAddress.regionCode !== 'DK') {
                            console.log('Invalid country');
                            isValid = false;
                        }

                        if (isValid) {
                            // Validation step 3
                            console.log(response.data.result.geocode.placeId);
                            axios.get(`https://places.googleapis.com/v1/places/${response.data.result.geocode.placeId}?key=AIzaSyDSSw89RnoedD7ChwJE6p2ACQ3GfMDqS1A&fields=addressComponents`)
                                .then((res) => {
                                    console.log(res.data.addressComponents);
                                    for (let i = 0; i < res.data.addressComponents.length; i++) {
                                        if (res.data.addressComponents[i].types.includes('locality') &&
                                            res.data.addressComponents[i].longText !== this.newDropoffAddress.city &&
                                            res.data.addressComponents[i].shortText !== this.newDropoffAddress.city
                                        ) {
                                            this.$set(this.errors, 'general', 'Invalid delivery info' );
                                            this.$set(this.errors, 'city', `Did you mean this one: ${res.data.addressComponents[i].longText}?` );
                                            isValid = false;
                                        }
                                        if (res.data.addressComponents[i].types.includes('postal_code') &&
                                            res.data.addressComponents[i].longText !== this.newDropoffAddress.zip &&
                                            res.data.addressComponents[i].shortText !== this.newDropoffAddress.zip
                                        ) {
                                            this.$set(this.errors, 'general', 'Invalid delivery info' );
                                            this.$set(this.errors, 'zip', `Did you mean this one: ${res.data.addressComponents[i].longText}?` );
                                            isValid = false;
                                        }
                                    }
                                })
                                .catch((error) => {
                                    this.$set(this.errors, 'general', 'Google maps error' );
                                    console.error(error);
                                    isValid = false;
                                });
                            if (isValid) {
                                resolve(true);
                            }
                        } else {
                            this.$set(this.errors, 'general', "There isn't enough information for the delivery. Or some information isn't valid" );
                            resolve(false);
                        }

                    }
                }).catch((error) => {
                    this.$set(this.errors, 'general', 'Google maps error' );
                    console.error(error);
                    resolve(false);
                });
            })
        },
    },
}

</script>

<style scoped>

</style>
